import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTableDnDBody from './ReactTableDnDBody';
import { ThemeProps } from '../../../prop-types/ReducerProps';



const ReactTableDefaultBody = ({ page, getTableBodyProps, prepareRow, useActions, Actions, refresh }) => {
  return (
  <tbody className="table table--bordered" {...getTableBodyProps()}>
    {page.map((row, index) => {
      prepareRow(row);
      return (
        <Fragment key={index}>
          <tr {...row.getRowProps()}>
            {row.cells.map(cell => (
              <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
            ))}
            { useActions? <Actions data={row} refresh={refresh} />: null}
          </tr>
        </Fragment>
      );
    })}
  </tbody>
)};

ReactTableDefaultBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  useActions: PropTypes.bool,
};

const ReactTableBody = ({
  page, getTableBodyProps, prepareRow, withDragAndDrop, updateDraggableData, theme, useActions, Actions, refresh
}) => (
  <Fragment>
    {withDragAndDrop
      ? (
        <ReactTableDnDBody
          page={page}
          getTableBodyProps={getTableBodyProps}
          prepareRow={prepareRow}
          updateDraggableData={updateDraggableData}
          theme={theme}
        />
      ) : (
        <ReactTableDefaultBody
          page={page}
          getTableBodyProps={getTableBodyProps}
          prepareRow={prepareRow}
          useActions={useActions}
          Actions={Actions}
          refresh={refresh}
        />
      )
    }
  </Fragment>
);

ReactTableBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  updateDraggableData: PropTypes.func.isRequired,
  withDragAndDrop: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
  useActions: PropTypes.bool,
};

export default connect(state => ({
  theme: state.theme,
}))(ReactTableBody);
